import { ISorgao, ISOrgaoList, Orgao, OrgaoList } from '../orgao/Orgao';

export interface Secretaria {
  id: string;
  nome: string | null;
  abreviatura?: string | null;
  descricao?: string | null;
  endereco?: string | null;
  numero?: string | null;
  complemento?: string | null;
  telefone?: string | null;
  bairro?: string | null;
  cidade?: string | null;
  cep?: string | null;
  orgao?: Orgao | null;
}

export const ISsecretaria: Secretaria = {
  id: '',
  nome: '',
  abreviatura: '',
  descricao: '',
  endereco: '',
  numero: '',
  complemento: '',
  telefone: '',
  bairro: '',
  cidade: '',
  cep: '',
  orgao: ISorgao
};

export interface SecretariaList {
  id: string;
  nome: string | null;
  abreviatura?: string | null;
  descricao?: string | null;
  orgao?: OrgaoList | null;
}

export const ISsecretariaList: SecretariaList = {
  id: '',
  nome: '',
  abreviatura: '',
  descricao: '',
  orgao: ISOrgaoList
};
